const STROKE = "currentColor";

function AttendantGlyph() {
  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden>
      <circle cx="24" cy="16" r="5.5" stroke={STROKE} strokeWidth="2.5" />
      <path
        d="M13 40v-2.5c0-5.2 4.9-9.5 11-9.5s11 4.3 11 9.5V40"
        stroke={STROKE}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function NurseGlyph() {
  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden>
      <path
        d="M14 30c0-7.2 4.5-13 10-13s10 5.8 10 13v2H14v-2z"
        stroke={STROKE}
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M17 17.5 20 13h8l3 4.5-2.5 1.5-2-3.5h-7l-2 3.5L17 17.5z"
        stroke={STROKE}
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path d="M24 20v4M22 22h4" stroke={STROKE} strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

function PhysioGlyph() {
  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden>
      <path d="M10 34h28" stroke={STROKE} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M14 34v-4M34 34v-4" stroke={STROKE} strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="18" cy="18" r="4" stroke={STROKE} strokeWidth="2.5" />
      <path d="M14 30c1.5-5 3.5-7 4-7s2.5 2 4 7" stroke={STROKE} strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="32" cy="17" r="3.75" stroke={STROKE} strokeWidth="2.5" />
      <path d="M28.5 30c.8-4 2-6 3.5-6s2.7 2 3.5 6" stroke={STROKE} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M30 24.5 34 28.5" stroke={STROKE} strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

function DementiaGlyph() {
  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden>
      <path
        d="M13 40V28c0-10 7-18.5 16.5-19 9.5-.5 17.5 7 17.5 19v12"
        stroke={STROKE}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M44 26v6" stroke={STROKE} strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="35" cy="24" r="1.75" fill={STROKE} />
      <path d="M32 31h5" stroke={STROKE} strokeWidth="2" strokeLinecap="round" />
      <path
        d="M19 15.5h5.5v3h3.5v3.5h-5.5v-3.5H16v-3.5h3V15.5z"
        stroke={STROKE}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PostOperativeGlyph() {
  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden>
      <path d="M10 34h28v3H10v-3z" stroke={STROKE} strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M14 34V30M34 34V30" stroke={STROKE} strokeWidth="2.5" strokeLinecap="round" />
      <rect x="16" y="24" width="16" height="6" rx="1.5" stroke={STROKE} strokeWidth="2.5" />
      <circle cx="30" cy="21" r="3.25" stroke={STROKE} strokeWidth="2.5" />
      <path d="M27 24c.5-2 1.8-3.5 3-3.5s2.5 1.5 3 3.5" stroke={STROKE} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M36 14v12" stroke={STROKE} strokeWidth="2.5" strokeLinecap="round" />
      <rect x="33.5" y="11" width="5" height="7" rx="1" stroke={STROKE} strokeWidth="2" />
    </svg>
  );
}

const CARE_TYPE_TAB_ICONS = {
  attendant: AttendantGlyph,
  nurses: NurseGlyph,
  physio: PhysioGlyph,
  dementia: DementiaGlyph,
  post_operative: PostOperativeGlyph,
};

export default function CareTypeTabIcon({ type }) {
  const Glyph = CARE_TYPE_TAB_ICONS[type] || CARE_TYPE_TAB_ICONS.attendant;

  return (
    <span className="landing-search-unified__tab-icon" aria-hidden>
      <Glyph />
    </span>
  );
}
